import { Card, Group, Heading, Input, Select, Skeleton, Stack, Text } from "@/components/ui";
import { BotonExportDocumentosCsv } from "./BotonExportDocumentosCsv";

/** Filtros de la sección documentos · todos se resuelven en el SERVIDOR. */
export function DocumentosFiltrosCard({
  numero,
  onNumeroChange,
  accion,
  onAccionChange,
  categoria,
  onCategoriaChange,
  categoriasDisponibles,
  total,
  desde,
  hasta,
}: {
  numero: string;
  onNumeroChange: (v: string) => void;
  accion: string;
  onAccionChange: (v: string) => void;
  categoria: string;
  onCategoriaChange: (v: string) => void;
  categoriasDisponibles: string[];
  /** undefined en la primera carga · barra skeleton en vez de «Sin eventos». */
  total: number | undefined;
  desde: number;
  hasta: number;
}) {
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group justify="space-between" align="flex-start">
          <div>
            <Heading order={5}>Filtros</Heading>
            <Text size="sm" c="dimmed" className="mt-0.5">
              Cargas y eliminaciones de documentos · filtrado y paginado en el
              servidor.
            </Text>
          </div>
          <BotonExportDocumentosCsv top={1000} />
        </Group>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <Input
            label="# Solicitud (substring)"
            placeholder="ej. 1024"
            value={numero}
            onChange={(e) => onNumeroChange(e.currentTarget.value)}
          />
          <Select
            label="Acción"
            options={[
              { value: "", label: "Todas" },
              { value: "Cargado", label: "Cargado" },
              { value: "Eliminado", label: "Eliminado" },
            ]}
            value={accion}
            onValueChange={onAccionChange}
          />
          <Select
            label="Categoría"
            options={[{ value: "", label: "Todas" }, ...categoriasDisponibles.map((c) => ({ value: c, label: c }))]}
            value={categoria}
            onValueChange={onCategoriaChange}
            searchable
          />
        </div>
        <Text size="xs" c="dimmed">
          {total === undefined ? (
            <Skeleton height={12} width={200} className="inline-block align-middle" aria-label="Cargando" />
          ) : total === 0
            ? "Sin eventos para los filtros."
            : `Mostrando ${desde}–${hasta} de ${total} eventos.`}
        </Text>
      </Stack>
    </Card>
  );
}
